import React, { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Alert,
    Container,
    Link
} from '@mui/material';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useNavigate } from 'react-router-dom';

export const ForgotPassword: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await sendPasswordResetEmail(auth, email);
            setSuccess(true);
            setEmail('');
        } catch (err: any) {
            setError('Şifre sıfırlama e-postası gönderilemedi. Lütfen e-posta adresinizi kontrol edip tekrar deneyin.');
            console.error('Şifre sıfırlama hatası:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 8, mb: 4 }}>
                <Paper sx={{ p: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center">
                        Şifremi Unuttum
                    </Typography>

                    {success ? (
                        <>
                            <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
                                Şifre sıfırlama bağlantısı e-posta adresinize gönderildi. Lütfen e-postanızı kontrol edin.
                            </Alert>
                            <Box sx={{ textAlign: 'center' }}>
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => navigate('/login')}
                                >
                                    Giriş sayfasına dön
                                </Link>
                            </Box>
                        </>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <Typography sx={{ mt: 2, mb: 4 }}>
                                Şifrenizi sıfırlamak için kayıtlı e-posta adresinizi girin. Size şifre sıfırlama bağlantısı göndereceğiz.
                            </Typography>

                            <TextField
                                fullWidth
                                label="E-posta"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                sx={{ mb: 3 }}
                            />

                            {error && (
                                <Alert severity="error" sx={{ mb: 3 }}>
                                    {error}
                                </Alert>
                            )}

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={loading}
                            >
                                {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama Bağlantısı Gönder'}
                            </Button>

                            <Box sx={{ textAlign: 'center', mt: 2 }}>
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => navigate('/login')}
                                >
                                    Giriş sayfasına dön
                                </Link>
                            </Box>
                        </form>
                    )}
                </Paper>
            </Box>
        </Container>
    );
}; 